import * as React from 'react';
import { Global } from '@emotion/react';
import {
  NavigationProvider,
  NavigationProviderProps,
} from './NavigationProvider/NavigationProvider';
import { SiflorMapProvider } from './SiflorMapProvider/SiflorMapProvider';
import GoogleMapsProvider from './GoogleMapsProvider/GoogleMapsProvider';
import ThemeProvider from './ThemeProvider/ThemeProvider';

type UiProviderProps = NavigationProviderProps & {
  children: React.ReactNode;
};

const UiProvider = ({ children, onLogout, onNavigate }: UiProviderProps) => {
  return (
    <NavigationProvider {...{ onLogout, onNavigate }}>
      <Global
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        styles={(theme: any) => {
          return {
            html: {
              scrollBehavior: 'smooth',
            },
            '*.introjs-tooltip': {
              color: theme?.colors?.text,
            },
            '*.introjs-tooltip *': {
              fontFamily: 'Overlock',
            },
            '*.introjs-tooltip a.introjs-button': {
              backgroundColor: theme?.colors?.primary,
              color: '#fff',
              textShadow: 'none',
              border: 'none',
              fontWeight: '700',
              boxShadow: '0px 4px 4px rgb(0 0 0 / 15%)',
              fontSize: '0.75rem',
            },
            '*.introjs-tooltip a.introjs-button.introjs-disabled': {
              opacity: 0.7,
            },
            '*.introjs-helperLayer': {
              boxShadow:
                'transparent 0px 0px 1px 2px, rgb(33 33 33 / 50%) 0px 0px 0px 5000px !important',
            },
            '.gmnoprint': {
              display: 'none',
            },
          };
        }}
      />
      <GoogleMapsProvider>
        <SiflorMapProvider>
          <ThemeProvider>{children}</ThemeProvider>
        </SiflorMapProvider>
      </GoogleMapsProvider>
    </NavigationProvider>
  );
};

export default UiProvider;
